import * as _ from 'react';
import ___default, { useMemo, useState, useCallback, useRef, useEffect } from 'react';
import { css, Global } from '@emotion/core';
import P from '@contentful/f36-tokens';
import { cx, css as css$1 } from 'emotion';

var me=Object.defineProperty,ce=Object.defineProperties;var de=Object.getOwnPropertyDescriptors;var A=Object.getOwnPropertySymbols;var v=Object.prototype.hasOwnProperty,j=Object.prototype.propertyIsEnumerable;var X=(e,t,o)=>t in e?me(e,t,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[t]=o,i=(e,t)=>{for(var o in t||(t={}))v.call(t,o)&&X(e,o,t[o]);if(A)for(var o of A(t))j.call(t,o)&&X(e,o,t[o]);return e},p=(e,t)=>ce(e,de(t));var c=(e,t)=>{var o={};for(var r in e)v.call(e,r)&&t.indexOf(r)<0&&(o[r]=e[r]);if(e!=null&&A)for(var r of A(e))t.indexOf(r)<0&&j.call(e,r)&&(o[r]=e[r]);return o};var ye=css`
  /* Remove default margin */
  /* Button has default margin in some browsers, like safari */
  body,
  h1,
  h2,
  h3,
  h4,
  p,
  figure,
  blockquote,
  dl,
  dd,
  button {
    margin: 0;
  }

  /* Remove list styles on ul, ol elements with a list role, which suggests default styling will be removed */
  ul[role='list'],
  ol[role='list'] {
    list-style: none;
  }

  /* Set core root defaults */
  html:focus-within {
    scroll-behavior: smooth;
  }

  /* Set core body defaults */
  body {
    text-rendering: optimizeSpeed;
    line-height: 1.5;
  }

  /* A elements that don't have a class get default styles */
  a:not([class]) {
    text-decoration-skip-ink: auto;
  }

  /* Make images easier to work with */
  img,
  picture {
    max-width: 100%;
    display: block;
  }

  /* Inherit fonts for inputs and buttons */
  input,
  button,
  textarea,
  select {
    font: inherit;
  }

  /* Remove all animations and transitions for people that prefer not to see them */
  @media (prefers-reduced-motion: reduce) {
    html:focus-within {
      scroll-behavior: auto;
    }
    *,
    *::before,
    *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }
`,W=({withNormalize:e=!0,styles:t})=>_.createElement(Global,{styles:css`
        ${e?ye:void 0};
        @font-face {
          font-family: 'Geist Mono';
          src: url('https://cdn.f36.contentful.com/fonts/geist-mono-1.4.01.woff2');
        }

        @font-face {
          font-family: 'Geist Sans';
          src: url('https://cdn.f36.contentful.com/fonts/geist-sans-1.4.01.woff2');
        }

        html {
          border: 0;
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }

        body {
          color: ${P.gray800};
          font-family: ${P.fontStackPrimary};
          font-size: ${P.fontSizeM};
          line-height: ${P.lineHeightM};
          font-synthesis-weight: none;
        }

        code {
          font-family: ${P.fontStackMonospace};
        }

        fieldset {
          border: 0;
          margin: 0;
          padding: 0;
        }

        *,
        *::after,
        *::before {
          -moz-osx-font-smoothing: grayscale;
          -webkit-font-smoothing: antialiased;
          box-sizing: inherit;
        }

        ${t};
      `});var ge={none:0,spacing2Xs:P.spacing2Xs,spacingXs:P.spacingXs,spacingS:P.spacingS,spacingM:P.spacingM,spacingL:P.spacingL,spacingXl:P.spacingXl,spacing2Xl:P.spacing2Xl,spacing3Xl:P.spacing3Xl,spacing4Xl:P.spacing4Xl};function m(e){return ge[e]}function H(e){return Object.assign({},e.margin?{margin:m(e.margin)}:null,e.marginLeft?{marginLeft:m(e.marginLeft)}:null,e.marginRight?{marginRight:m(e.marginRight)}:null,e.marginTop?{marginTop:m(e.marginTop)}:null,e.marginBottom?{marginBottom:m(e.marginBottom)}:null,e.padding?{padding:m(e.padding)}:null,e.paddingLeft?{paddingLeft:m(e.paddingLeft)}:null,e.paddingRight?{paddingRight:m(e.paddingRight)}:null,e.paddingTop?{paddingTop:m(e.paddingTop)}:null,e.paddingBottom?{paddingBottom:m(e.paddingBottom)}:null)}var xe="div";function g(e){let E=e,{display:t,className:o,margin:r,marginBottom:a,marginLeft:s,marginRight:n,marginTop:l,padding:d,paddingBottom:f,paddingLeft:y,paddingRight:u,paddingTop:x,testId:R,as:h=xe}=E,T=c(E,["display","className","margin","marginBottom","marginLeft","marginRight","marginTop","padding","paddingBottom","paddingLeft","paddingRight","paddingTop","testId","as"]);return {boxProps:i({className:cx(css$1({display:t}),css$1(i({},H({margin:r,marginBottom:a,marginLeft:s,marginRight:n,marginTop:l,padding:d,paddingBottom:f,paddingLeft:y,paddingRight:u,paddingTop:x}))),o),"data-test-id":R},T),Element:h}}function K(e,t){let{boxProps:o,Element:r}=g(e);return _.createElement(r,p(i({},o),{ref:t}),e.children)}K.displayName="Box";var q=_.forwardRef(K);var Ee="div";function V(Ne,se){var U=Ne,{isInline:e,alignItems:t,alignSelf:o,alignContent:r,flex:a,flexBasis:s,flexShrink:n,flexDirection:l,flexGrow:d,flexWrap:f,fullHeight:y,fullWidth:u,gap:x,justifyContent:R,justifyItems:h,justifySelf:T,order:b,children:E,as:I}=U,G=c(U,["isInline","alignItems","alignSelf","alignContent","flex","flexBasis","flexShrink","flexDirection","flexGrow","flexWrap","fullHeight","fullWidth","gap","justifyContent","justifyItems","justifySelf","order","children","as"]);var N;let{boxProps:O,Element:le}=g(p(i({},G),{as:I||Ee}));return _.createElement(le,p(i({},O),{className:cx(css$1({display:e?"inline-flex":"flex",width:u?"100%":void 0,height:y?"100%":void 0,flex:a,flexBasis:s,flexShrink:n,flexDirection:l,gap:x==="none"?0:(N=P[x])!=null?N:x,justifyContent:R,justifyItems:h,justifySelf:T,alignItems:t,alignSelf:o,alignContent:r,order:b,flexWrap:f,flexGrow:d}),O.className),ref:se}),E)}V.displayName="Flex";var k=_.forwardRef(V);var Ge="div";function Q(x,u){var R=x,{alignContent:e,children:t,columnGap:o="spacingM",columns:r="auto",flow:a,isInline:s,justifyContent:n,rowGap:l="none",rows:d="auto",as:f}=R,y=c(R,["alignContent","children","columnGap","columns","flow","isInline","justifyContent","rowGap","rows","as"]);var E,I;let h=G=>typeof G=="number"?`repeat(${G}, minmax(0, 1fr))`:G,{boxProps:T,Element:b}=g(p(i({},y),{as:f||Ge}));return _.createElement(b,p(i({},T),{className:cx(css$1({display:s?"inline-grid":"grid",gridTemplateColumns:h(r),gridTemplateRows:h(d),flow:a,justifyContent:n,alignContent:e,columnGap:(E=m(o))!=null?E:0,rowGap:(I=m(l))!=null?I:0}),T.className),ref:u}),t)}Q.displayName="Grid";var Y=_.forwardRef(Q);function Z(f,d){var y=f,{children:e,columnStart:t,columnEnd:o,rowStart:r,rowEnd:a,area:s,order:n}=y,l=c(y,["children","columnStart","columnEnd","rowStart","rowEnd","area","order"]);let u=s||[r||"auto",t||"auto",a||"auto",o||"auto"].join(" / "),{boxProps:x,Element:R}=g(l);return _.createElement(R,p(i({},x),{className:cx(css$1({gridArea:u,order:n}),x.className),ref:d}),e)}Z.displayName="GridItem";var w=_.forwardRef(Z);var M=Y;M.Item=w;var Ie="div";function ee(d,l){var f=d,{flexDirection:e="row",alignItems:t="center",isInline:o=!1,spacing:r="spacingM",children:a,as:s}=f,n=c(f,["flexDirection","alignItems","isInline","spacing","children","as"]);let{boxProps:y,Element:u}=g(p(i({},n),{as:s||Ie}));return _.createElement(k,p(i({},y),{as:u,flexDirection:e,alignItems:t,isInline:o,className:y.className,gap:r,ref:l}),a)}ee.displayName="Stack";var te=_.forwardRef(ee);function oe(){return {screenReaderOnly:css$1({position:"absolute",width:"1px",height:"1px",padding:0,margin:"-1px",overflow:"hidden",clip:"rect(0, 0, 0, 0)",border:0})}}var re=s=>{var n=s,{children:e,className:t,testId:o="cf-ui-ScreenReaderOnly",as:r="div"}=n,a=c(n,["children","className","testId","as"]);let l=oe();return ___default.createElement(r,p(i({},a),{"data-test-id":o,className:cx(l.screenReaderOnly,t)}),e)};function ne(e,t){return useMemo(()=>e||[t||"id",Math.round(Math.random()*1e4)].join("_"),[])}function ie({isOpen:e,defaultIsOpen:t,onOpen:o,onClose:r}){let[a,s]=useState(t||!1),n=e!==void 0,l=n?e:a,d=useCallback(()=>{n||s(!1),r==null||r();},[n,r]),f=useCallback(()=>{n||s(!0),o==null||o();},[n,o]);return {isOpen:l,isControlled:n,handleClose:d,handleOpen:f}}function pe({onLoad:e}={}){let[t,o]=useState(!1),r=useRef(),a=useCallback(()=>{e==null||e(),o(!0);},[e]);return useEffect(()=>{r.current&&r.current.complete&&a();},[a]),{ref:r,loaded:t,onLoad:a}}function Ue(...e){return t=>{e.forEach(o=>{typeof o=="function"?o(t):o!=null&&(o.current=t);});}}var Oe=({status:e})=>{switch(e){case"published":return {color:P.colorGreenBase,backgroundColor:P.colorGreenLightest};case"changed":return {color:P.colorBlueBase,backgroundColor:P.colorBlueLightest};case"deleted":case"archived":return {color:P.colorRedBase,backgroundColor:P.colorRedLightest};case"draft":return {color:P.colorOrangeDark,backgroundColor:"#ffefd5"};case"new":return {color:P.colorWhite,backgroundColor:P.blue500};default:return console.warn(`Unknown EntityStatus: ${e}`),{}}};

export { q as Box, k as Flex, W as GlobalStyles, M as Grid, w as GridItem, re as ScreenReaderOnly, te as Stack, Oe as getEntityStatusStyles, Ue as mergeRefs, g as useBox, ie as useControllableState, ne as useId, pe as useImageLoaded };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.js.map